<template>
  <div>
    <div class="row" v-if="quiz && error == ''">
      <div v-if="analysis && analysis.questions.length > 0">
        <div class="text-right mr-20">
          <a class="btn green" v-on:click="saveAnalysis()">Enregistrer</a>
        </div>

        <div class="col-xs-12" v-for="(question, question_index) in quiz.questions" v-if="question.type == 'text' || (question.type == 'checkbox_multiple' && haveText(question)) || (question.type == 'radio_multiple' && haveText(question))">
          <div class="mt-element-ribbon col-xs-12 p-0 mb-10">
            <div class="ribbon ribbon-border-hor ribbon-clip ribbon-color-info uppercase">
              <div class="ribbon-sub ribbon-clip"></div> Question n°{{question_index+1}}
            </div>
          </div>
          <div class="col-xs-12 p-0 mb-30">
            <div class="form-group form-md-line-input">
              <label class="col-sm-10 col-sm-offset-1 p-0 control-label" v-if="question.type == 'text'">
                <h4 class="p-0">{{question.title}}</h4>
              </label>
              <label class="col-sm-10 col-sm-offset-1 p-0 control-label" v-if="question.type == 'checkbox_multiple' || question.type == 'radio_multiple'">
                <h4 class="p-0">{{question.title}}</h4>
              </label>
              <div class="col-sm-10 col-sm-offset-1 p-0" style="background-color:#f1f1f1" v-if="question.type == 'text'">
                <textarea type="text" placeholder="" rows="6" class="form-control" v-if="analysis.questions[question_index]" v-model="analysis.questions[question_index].text" style="padding:10px"></textarea>
                <div class="form-control-focus"></div>
                <!-- <span class="help-block">La description apparaîtra en dessous du titre pour expliquer votre question si besoin.</span> -->
              </div>
              <div class="col-xs-12" v-for="(data, data_index) in question.data" v-if="(question.type == 'checkbox_multiple' || question.type == 'radio_multiple') && data.question && data.question.type == 'text'">
                <label class="col-sm-10 col-sm-offset-1 p-0 control-label">
                  <h5 class="p-0">{{data.name}} : {{data.question.title}}</h5>
                </label>
                <div class="col-sm-10 col-sm-offset-1 p-0" style="background-color:#f1f1f1">
                  <textarea type="text" placeholder="" rows="6" class="form-control" v-if="analysis.questions[question_index] && analysis.questions[question_index].data[data_index]" v-model="analysis.questions[question_index].data[data_index].text" style="padding:10px"></textarea>
                  <div class="form-control-focus"></div>
                  <!-- <span class="help-block">La description apparaîtra en dessous du titre pour expliquer votre question si besoin.</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12">
          <div class="form-actions col-xs-12">
            <div class="row">
              <div class="text-left" style="float:left;">
                <a class="btn default" v-on:click="$router.back()">Annuler</a>
              </div>
              <div class="text-right">
                <a class="btn green" v-on:click="saveAnalysis()">Enregistrer</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="col-xs-12 m-30">
        Aucune question ouverte pour ce formulaire.
      </div>
    </div>
    <div class="row m-0" v-if="!quiz">
      <div class="col-md-12 page-404 mt-50 pb-50">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Analyse du questionnaire non trouvée.</h3>
              <p> Nous n'avons pas réussi à trouver cette analyse.
                  <br>
                  Vérifiez'url et tentez de recharger la page.
              </p>
          </div>
      </div>
    </div>
    <div class="row m-0 page-404-full-page" v-if="error != ''">
      <div class="col-md-12 page-404 pb-100">
          <div class="number error font-green"> Erreur </div>
          <div class="details">
              <h3>Oops ! Une erreur est survenue</h3>
              <p> {{error}}
                  <br>
                  Vérifiez l'url et tentez de recharger la page.
              </p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

  import quizzes from '../../../requests/quizzes.js'

  export default {
    created () {
    },
    data(){
      return{
        quiz:{},
        analysis:{
          questions:[]
        },
        error:""
      }
    },
    mounted:function(){
      var parent = this;
      if(this.$route.params && this.$route.params.slug){
        quizzes.getBySlug(this,this.$route.params.slug,function(quiz,err){
          if(quiz){
            quizzes.getQuestions(parent,parent.$route.params.slug,function(questions,err_questions){
              if(questions){
                quiz["questions"] = questions;
                // Get les ANALYSE.
                quizzes.getAnalysis(parent,parent.$route.params.slug,function(analysis,err){
                  if(analysis){
                    quiz["analysis"] = analysis;
                    parent.analysis = analysis;
                  }
                  else{
                    var noOpenQuestion = true;
                    for(var q=0;q<quiz.questions.length;q++){
                      if(quiz.questions[q].type == "text"){
                        noOpenQuestion = false;
                      }
                      var data = [];
                      if(quiz.questions[q].type == "checkbox_multiple" || quiz.questions[q].type == "radio_multiple"){
                        for(var d=0;d<quiz.questions[q].data.length;d++){
                          if(quiz.questions[q].data[d].question && quiz.questions[q].data[d].question.type == "text"){
                            noOpenQuestion = false;
                          }
                          data.push({text:"",parent:quiz.questions[q].data[d].name,questionId:quiz.questions[q].id})
                        }
                      }

                      parent.analysis.questions.push({
                        text: "",
                        questionId:quiz.questions[q].id,
                        data:data
                      })
                    }
                    if(noOpenQuestion){
                      parent.analysis.questions = [];
                    }
                  }
                  parent.quiz = quiz;
                })
              }
              else{
                parent.error = "Impossible de récupérer les questions du questionnaire."
                toastr.error("Impossible de récupérer les questions du questionnaire.","ERREUR");
              }
            })
          }
          else{
            parent.quiz = null;
            toastr.error("Impossible de récupérer le questionnaire.","ERREUR");
          }
        })
      }
      else{
        this.quiz = null;
      }
    },
    methods:{
      haveText(question){
        if(question.type == "checkbox_multiple" || question.type == "radio_multiple"){
          for(var d=0;d<question.data.length;d++){
            if(question.data[d].question && question.data[d].question.type == "text")
              return true;
          }
        }
        return false;
      },
      saveAnalysis(){
        var parent = this;
        if(this.quiz.analysis){
          quizzes.updateAnalysis(this,this.quiz.slug,this.analysis,function(analysis,err){
            if(analysis){
              toastr.success("L'analyse a bien été mise à jour.");
            }
            else{
              toastr.error("Impossible de mettre à jour l'analyse.","ERREUR");
            }
          })
        }
        else{
          quizzes.createAnalysis(this,this.quiz.slug,this.analysis,function(analysis,err){
            if(analysis){
              parent.quiz.analysis = analysis;
              toastr.success("L'analyse a bien été créée.");
            }
            else{
              toastr.error("Impossible de créer l'analyse.","ERREUR");
            }
          })
        }
      }
    }
  }
</script>

<style scoped>
  
</style>
<style src="../../../assets/theme/css/error.min.css"></style>



// WEBPACK FOOTER //
// analysis.vue?47b56c22